<template>
  <img :data-src="src" :data-srcset="srcset" :alt="alt" @error="handleError">
</template>

<script>
import AppLazyImgPlugin from '../plugins/lazyImg/AppLazyImgPlugin.js';

export default {
  name: 'app-img',

  props: {
    src: String,
    srcset: String,
    alt: String
  },

  data() {
    return {};
  },

  methods: {
    handleError() {
      return false;
    }
  },

  mounted() {
    this.$nextTick(() => {
      AppLazyImgPlugin.lazyImgs.push(this.$el);
      AppLazyImgPlugin.check(this.$el);
    });
  },

  destroyed() {
    AppLazyImgPlugin.lazyImgs = AppLazyImgPlugin.lazyImgs.filter((img) => img !== this.$el);
  }
}
</script>

<style scoped>

</style>